// para obtener todas las MODIFICACIONES tanto de planta como proveedores
export const GET_MODIFICACIONES_LIST_SUCCESS = 'GET_MODIFICACIONES_LIST_SUCCESS';
export const GET_MODIFICACIONES_LIST_FAIL = 'GET_MODIFICACIONES_LIST_FAIL';

export const GET_MODIFICACIONES_SUCCESS = 'GET_MODIFICACIONES_SUCCESS';
export const GET_MODIFICACIONES_FAIL = 'GET_MODIFICACIONES_FAIL';  

export const GET_MODIFICACIONES_SEARCH_SUCCESS = 'GET_MODIFICACIONES_SEARCH_SUCCESS';
export const GET_MODIFICACIONES_SEARCH_FAIL = 'GET_MODIFICACIONES_SEARCH_FAIL';